module.exports = __webpack_public_path__ + "img/fif-photo-placeholder.d0a6bdce.jpg";